import pickBy from 'lodash/pickBy';
import omit from 'lodash/omit';
import { IGetOffersCompilationsDataFormatted, IGetPlacementsDataFormatted } from '@api/types';
import { IFilters } from './interfaces';

// ToDo избавиться от lodash
const prepareFilters = (
    filters: IFilters,
    offersCompilationsData?: IGetOffersCompilationsDataFormatted[],
    currentPlacement?: IGetPlacementsDataFormatted | null,
): Record<string, unknown> => {
    const result = pickBy(filters, item => !!item);
    const ids = [];
    const trafficSources = filters.trafficSources?.filter(source => !!+source);
    const compilationIds = [
        ...filters.categoriesIds?.filter(id => !!+id),
        ...filters.compilationIds,
    ];
    compilationIds?.forEach(compilation => {
        const find = offersCompilationsData?.find(
            offerCompilation => Number(offerCompilation.id) === Number(compilation),
        );
        if (find && find.offersIds?.length > 0) {
            ids.push(...find.offersIds);
        }
    });
    if (filters.labelIds) {
        result.labelIds = [+filters.labelIds];
    }
    if (currentPlacement && currentPlacement?.trafficSourceId && filters.suitablePlacements) {
        result.trafficSources = [...trafficSources, currentPlacement?.trafficSourceId];
    } else {
        result.trafficSources = trafficSources;
    }

    if (ids.length > 0) {
        result.ids = ids;
    }
    return omit(result);
};

export default prepareFilters;
